import { render } from "./AppDownloadPopup.vue?vue&type=template&id=71fc1b15&scoped=true"
import script from "./AppDownloadPopup.vue?vue&type=script&lang=js"
export * from "./AppDownloadPopup.vue?vue&type=script&lang=js"

import "./AppDownloadPopup.vue?vue&type=style&index=0&id=71fc1b15&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71fc1b15"]])

export default __exports__